const amplifyConfigs = require(`./amplify-configs.${
  process.env.REACT_APP_SERVICE_ENV || "local"
}`).default;

export default amplifyConfigs;
